"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResources = void 0;
var textures_1 = require("./textures");
var three_1 = require("three");
var textureLoader = new three_1.TextureLoader();
var cubeTextureLoader = new three_1.CubeTextureLoader();
var getTexture = function (source) {
    var prm = new Promise(function (res, rej) {
        textureLoader.load(source.path, function (texture) {
            res({
                name: source.name,
                content: texture
            });
        }, null, rej);
    });
    return prm;
};
var getCubeTexture = function (source) {
    var prm = new Promise(function (res, rej) {
        cubeTextureLoader.load(source.paths, function (texture) {
            res({
                name: source.name,
                content: texture
            });
        }, null, function (error) { console.log(error); });
    });
    return prm;
};
var getResources = function () {
    var promiseArr = [];
    for (var _i = 0, textureSources_1 = textures_1.textureSources; _i < textureSources_1.length; _i++) {
        var textureSource = textureSources_1[_i];
        switch (textureSource.type) {
            case 'cubeTexture':
                promiseArr.push(getCubeTexture(textureSource));
                break;
            case 'texture':
                promiseArr.push(getTexture(textureSource));
                break;
        }
    }
    return Promise.all(promiseArr).then(function (values) {
        var result = {};
        values.forEach(function (sourceObj) {
            result[sourceObj.name] = sourceObj.content;
        });
        return result;
    });
};
exports.getResources = getResources;
